import { Injectable } from '@angular/core';

@Injectable()
export class DateHelper{
    currentYear(){
        return new Date().getFullYear();
    }

    getLastXYears(nbYears){
        let years=[];
        const currentYear = new Date().getFullYear();
        for(let i = 0; i<=nbYears;i++){
            years.push(currentYear-i).toString();
        }
        return years;
    }

    getMonth(){
        let months = [];
        months[1]="Janvier";
        months[2]="Février";
        months[3]="Mars";
        months[4]="Avril";
        months[5]="Mai";
        months[6]="Juin";
        months[7]="Juillet";
        months[8]="Août";
        months[9]="Septembre";
        months[10]="Octobre";
        months[11]="Novembre";
        months[12]="Décembre";
        return months;
    }

    setDatepickerValueToDate(dpValue){
        const d = new Date(dpValue);
        let month = (d.getMonth()+1)<10?"0"+(d.getMonth()+1):(d.getMonth()+1);
        let day = d.getDate()<10?"0"+d.getDate():d.getDate();
        const year = d.getFullYear();
    
        return year+"-"+month+"-"+day;
    }

    
}

export const _dbDateTimeToFRDateTime = (value)=>{

    if(value != null){
    const y = value.substring(0,4);
    const m = value.substring(5,7);
    const d = value.substring(8,10);
    const h = value.substring(11,13);
    const mi = value.substring(14,16);
    const s = value.substring(17,19);
    return d+"/"+m+"/"+y+" à "+h+"h"+mi;
  }

  return "-"
  
}

export const _dbDateToFRDate = (value)=>{

    if(value != null){
    const y = value.substring(0,4);
    const m = value.substring(5,7);
    const d = value.substring(8,10);
   
    return d+"/"+m+"/"+y;
  }

  return "-"
  
}


function getMonth(){
    let months = [];
    months[1]="Janvier";
    months[2]="Février";
    months[3]="Mars";
    months[4]="Avril";
    months[5]="Mai";
    months[6]="Juin";
    months[7]="Juillet";
    months[8]="Août";
    months[9]="Septembre";
    months[10]="Octobre";
    months[11]="Novembre";
    months[12]="Décembre";
    return months;
}

export function _dateToMoisAnneeLitteral(dateStr){
    const mois = parseInt(dateStr.split("-")[1]);
    const annee = dateStr.split("-")[0];
    return getMonth()[mois]+" "+annee
}

export function getThirdMonday(year, month) {
    // Créez une date pour le premier jour du mois donné
    const firstDayOfMonth = new Date(year, month, 1);
    
    // Obtenez le jour de la semaine du premier jour du mois (0 pour dimanche, 1 pour lundi, etc.)
    const firstDayOfWeek = firstDayOfMonth.getDay();
    
    // Calculez le décalage pour obtenir le premier lundi du mois
    const offset = (8 - firstDayOfWeek) % 7;
    
    // Ajoutez le décalage plus deux semaines (14 jours) pour obtenir le troisième lundi
    const thirdMonday = new Date(year, month, 1 + offset + 14);
    
    // Formatez la date en dd/mm/yyyy
    const day = String(thirdMonday.getDate()).padStart(2, '0');
    const formattedMonth = String(thirdMonday.getMonth() + 1).padStart(2, '0');
    const yearFormatted = thirdMonday.getFullYear();
    
    return `${day}/${formattedMonth}/${yearFormatted}`;
}